module.exports = __webpack_public_path__ + "static/media/solution-1-sec3.5a0c5743.png";